import { createReadGeneration, scopeObservationKey } from './observations';
import type { ObservationIdentity, ResolvedScope } from './types';
const generation = createReadGeneration();
let identity: ObservationIdentity = { principalKey: '', sessionEpoch: '', permissionEpoch: '' };
let scope: ResolvedScope = { kind: 'pending' };
let version = '';
export function activateObservationScope(nextIdentity: ObservationIdentity, nextScope: ResolvedScope): void {
  const next = JSON.stringify([nextIdentity, nextScope]);
  if (next === version) return;
  generation.advance(); identity = nextIdentity; scope = nextScope; version = next;
}
export const captureObservation = () => generation.capture();
export const assertObservation = generation.assertCurrent;
export const invalidateObservations = () => { generation.advance(); version = ''; };
export function assertScopedMutation(path: string): void {
  if (/^\/(backup|demo-env|environments|releases|recovery|budgets|metering|investigations|portal-config-draft|operations)(\/|$)/.test(path)
    && scope.kind !== 'environment') throw new Error('A concrete registered global scope is required; All is read-only');
}
export function currentObservationKey(...parts: unknown[]): unknown[] {
  // Explicit blocked namespace is never a readable environment or an anonymous cache.
  if (scope.kind !== 'all' && scope.kind !== 'environment') return ['scope-blocked', version, ...parts];
  return [...scopeObservationKey(identity, scope, 'dashboard'), ...parts];
}
export function requireConcreteEnvironment(value: string | null | undefined): string {
  if (!value || ['all', 'ALL', 'unavailable'].includes(value)) throw new Error('Select a registered environment for this operation');
  return value;
}
export function isScopeCancellation(error: unknown): boolean {
  return error instanceof Error && ['StaleObservationError', 'CanceledError', 'AbortError'].includes(error.name);
}
